/* iwobbl preset-first designer entry.
 * The default /pages/design route renders this picker without starting the
 * catalog/engine. DIY and template routes reveal the existing designer. */
(function () {
  'use strict';

  var entry = window.__iwDesignerEntry || { mode: 'designer', showPicker: false };
  var picker = document.getElementById('iwDesignTemplatePicker');
  var designer = document.getElementById('iwobblDesignerApp');

  function revealDesigner() {
    if (picker) {
      picker.hidden = true;
      picker.setAttribute('inert', '');
    }
    if (designer) {
      designer.hidden = false;
      designer.removeAttribute('inert');
    }
  }

  if (!picker || entry.mode !== 'picker') {
    revealDesigner();
    return;
  }

  if (designer) {
    designer.hidden = true;
    designer.setAttribute('inert', '');
  }
  picker.hidden = false;
  picker.removeAttribute('inert');

  var BASE = '/apps/design/api/design-templates';
  var productTabsNode = document.getElementById('iwDesignTemplateProductTabs');
  var themesNode = document.getElementById('iwDesignTemplateThemes');
  var countNode = document.getElementById('iwDesignTemplateCount');
  var progressNode = document.getElementById('iwDesignTemplateProgress');
  var statusNode = document.getElementById('iwDesignTemplateStatus');
  var listNode = document.getElementById('iwDesignTemplateList');
  var blankButton = document.getElementById('iwDesignTemplateStartBlank');
  var chooserRoot = document.getElementById('iwDesignChooser');
  var chooserDialog = document.getElementById('iwDesignChooserDialog');
  var chooserGrid = document.getElementById('iwDesignChooserGrid');
  var chooserTitle = document.getElementById('iwDesignChooserTitle');
  var chooserClose = document.getElementById('iwDesignChooserClose');
  var chooserBackdrop = document.getElementById('iwDesignChooserBackdrop');
  var startedAt = window.__iwTemplateListBootstrap && window.__iwTemplateListBootstrap.startedAt;
  if (!Number.isFinite(Number(startedAt))) startedAt = performance.now();

  var state = {
    items: [],
    themes: [],
    productType: entry.productType === 'necklace' ? 'necklace' : 'bracelet',
    activeIndexByType: { bracelet: 0, necklace: 0 },
    activeDesignIdByType: { bracelet: '', necklace: '' },
    cacheByType: { bracelet: null, necklace: null },
    activeTheme: 'all',
    imageIndexes: new Map(),
    currency: (window.IWCurrency && window.IWCurrency.context.currencyCode) || 'USD',
    retryCount: 0,
    galleryInteractionCount: 0,
    viewedTemplateKeys: new Set(),
    selectedTemplate: null,
    startedBlank: false,
    exitSent: false,
    maxScrollPct: 0,
    requestController: null,
    cardViewTimer: 0,
    chooserReturnFocus: null,
    chooserPreviousOverflow: '',
    chooserPickerWasInert: false,
    navigationPending: false,
    loadingProductType: false,
  };

  function track(name, params) {
    var send = function () {
      if (window.IWAnalytics && typeof window.IWAnalytics.track === 'function') {
        window.IWAnalytics.track(name, params || {});
      }
    };
    if (window.IWAnalytics && typeof window.IWAnalytics.track === 'function') send();
    else window.addEventListener('iwobbl:analytics-ready', send, { once: true });
  }

  function trackAndFlush(name, params) {
    track(name, params);
    if (window.IWAnalytics && typeof window.IWAnalytics.flush === 'function') {
      window.IWAnalytics.flush(true);
    }
  }

  function analyticsErrorCode(error, fallback) {
    var raw = error && (error.code || error.name || error.message);
    return String(raw || fallback || 'unknown')
      .toLowerCase()
      .replace(/[^a-z0-9_:-]+/g, '_')
      .slice(0, 80) || fallback || 'unknown';
  }

  function safeIdentifier(value) {
    var id = String(value || '').trim();
    return id && id.length <= 128 && /^[a-zA-Z0-9_:-]+$/.test(id) ? id : '';
  }

  function safeRemoteImageUrl(value) {
    var input = String(value || '').trim();
    if (!input) return '';
    try {
      var parsed = new URL(input);
      if (parsed.protocol !== 'https:' || parsed.username || parsed.password) return '';
      var hostname = parsed.hostname.toLowerCase().replace(/^\[|\]$/g, '');
      var privateIpv4 = /^(?:127\.|10\.|192\.168\.|169\.254\.|172\.(?:1[6-9]|2\d|3[01])\.)/.test(hostname);
      if (
        hostname === 'localhost'
        || hostname === '0.0.0.0'
        || hostname === '::1'
        || hostname.endsWith('.localhost')
        || privateIpv4
        || parsed.pathname.startsWith('/api/designer/local-previews/')
      ) {
        return '';
      }
      return parsed.href;
    } catch (error) {
      return '';
    }
  }

  function imageValue(image) {
    if (typeof image === 'string') return { url: image, alt: '' };
    if (!image || typeof image !== 'object') return { url: '', alt: '' };
    return {
      url: image.url || image.imageUrl || image.src || '',
      alt: image.alt || image.altText || '',
    };
  }

  function normalizeImages(item) {
    var images = [];
    var seen = new Set();
    var rawImages = [];
    if (item && item.cover) rawImages.push(item.cover);
    if (item && Array.isArray(item.images)) {
      item.images.forEach(function (image) { rawImages.push(image); });
    }
    rawImages.forEach(function (rawImage) {
      var value = imageValue(rawImage);
      var url = safeRemoteImageUrl(value.url);
      if (!url || seen.has(url)) return;
      seen.add(url);
      images.push({ url: url, alt: String(value.alt || '').trim() });
    });
    return images;
  }

  function normalizeItem(item, position, templateCount) {
    var sourceDesignId = safeIdentifier(item && item.sourceDesignId);
    var images = normalizeImages(item);
    var priceCents = Number(item && item.priceCents);
    var usable = item && item.available !== false && item.priceComplete !== false;
    if (!usable || !sourceDesignId || !images.length || !Number.isFinite(priceCents)) return null;
    var productType = item.productType === 'necklace' ? 'necklace' : 'bracelet';
    return {
      sourceDesignId: sourceDesignId,
      title: String(item.title || 'Untitled design').trim(),
      themeId: String(item.themeId || '').trim(),
      themeHandle: String(item.themeHandle || item.themeId || 'other').trim() || 'other',
      themeName: String(item.themeName || 'Other').trim() || 'Other',
      subthemeName: String(item.subthemeName || '').trim(),
      productType: productType,
      beadCount: Math.max(0, Number(item.beadCount) || 0),
      priceCents: Math.round(priceCents),
      currency: String(item.currency || state.currency || 'USD').toUpperCase(),
      images: images,
      position: position,
      templateCount: templateCount,
    };
  }

  function normalizeTheme(theme) {
    if (!theme || typeof theme !== 'object') return null;
    var handle = String(theme.themeHandle || theme.handle || theme.id || '').trim();
    var name = String(theme.themeName || theme.name || '').trim();
    if (!handle || !name) return null;
    return { handle: handle, name: name };
  }

  function normalizeResponse(data) {
    var rawItems = data && Array.isArray(data.items) ? data.items : [];
    state.currency = String((data && data.currency) || state.currency || 'USD').toUpperCase();
    var items = rawItems
      .map(function (item) { return normalizeItem(item, 0, 0); })
      .filter(Boolean);
    items.forEach(function (item, index) {
      item.position = index + 1;
      item.templateCount = items.length;
    });
    var usedHandles = new Set(items.map(function (item) { return item.themeHandle; }));
    var themes = [];
    var seen = new Set();

    (data && Array.isArray(data.themes) ? data.themes : []).forEach(function (rawTheme) {
      var theme = normalizeTheme(rawTheme);
      if (!theme || seen.has(theme.handle) || !usedHandles.has(theme.handle)) return;
      seen.add(theme.handle);
      themes.push(theme);
    });
    items.forEach(function (item) {
      if (seen.has(item.themeHandle)) return;
      seen.add(item.themeHandle);
      themes.push({ handle: item.themeHandle, name: item.themeName });
    });
    return { items: items, themes: themes };
  }

  function templateListUrl() {
    var url = window.IWCurrency ? window.IWCurrency.withContext(BASE) : BASE;
    url += (url.indexOf('?') >= 0 ? '&' : '?')
      + 'productType=' + encodeURIComponent(state.productType);
    return url;
  }

  async function requestTemplates(force) {
    var url = templateListUrl();
    var bootstrap = window.__iwTemplateListBootstrap;
    if (
      !force
      && bootstrap
      && bootstrap.url === url
      && bootstrap.dataPromise
      && typeof bootstrap.dataPromise.then === 'function'
    ) {
      return await bootstrap.dataPromise;
    }

    if (state.requestController) state.requestController.abort();
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    state.requestController = controller;
    var timeoutId = controller ? window.setTimeout(function () { controller.abort(); }, 12000) : 0;
    try {
      var options = { credentials: 'same-origin', cache: 'no-store' };
      if (controller) options.signal = controller.signal;
      var response = await fetch(url, options);
      var data = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        var error = new Error(data.error || ('design-templates ' + response.status));
        error.code = data.error || 'template_list_failed';
        throw error;
      }
      return data;
    } finally {
      if (timeoutId) window.clearTimeout(timeoutId);
      if (state.requestController === controller) state.requestController = null;
    }
  }

  function element(tagName, className, text) {
    var node = document.createElement(tagName);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function productLabel(item) {
    var product = item.productType === 'necklace' ? 'Necklace' : 'Bracelet';
    var beads = item.beadCount === 1 ? '1 bead' : item.beadCount + ' beads';
    return product + ' · ' + beads;
  }

  function priceLabel(item) {
    if (window.IWCurrency && typeof window.IWCurrency.formatMinor === 'function') {
      return window.IWCurrency.formatMinor(item.priceCents, item.currency);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: item.currency,
      }).format(item.priceCents / 100);
    } catch (error) {
      return '$' + (item.priceCents / 100).toFixed(2);
    }
  }

  function cyclicIndex(index, delta, length) {
    if (!length) return 0;
    return (index + delta % length + length) % length;
  }

  function filteredItems() {
    if (state.activeTheme === 'all') return state.items;
    return state.items.filter(function (item) { return item.themeHandle === state.activeTheme; });
  }

  function activeIndex() {
    var maximum = Math.max(0, state.items.length - 1);
    var index = Math.max(0, Math.min(maximum, Number(state.activeIndexByType[state.productType]) || 0));
    state.activeIndexByType[state.productType] = index;
    return index;
  }

  function activeItem() {
    return state.items[activeIndex()] || null;
  }

  function restorePickerState() {
    try {
      var raw = sessionStorage.getItem('iw_template_picker_single_card_v1');
      var saved = raw ? JSON.parse(raw) : null;
      if (!saved || Date.now() - Number(saved.updatedAt || 0) > 30 * 60 * 1000) return;
      ['bracelet', 'necklace'].forEach(function (type) {
        var id = safeIdentifier(saved.activeDesignIdByType && saved.activeDesignIdByType[type]);
        if (id) state.activeDesignIdByType[type] = id;
      });
      if (!entry.productTypeExplicit && (saved.productType === 'bracelet' || saved.productType === 'necklace')) {
        state.productType = saved.productType;
      }
    } catch (error) {}
  }

  function savePickerState() {
    try {
      var item = activeItem();
      if (item) state.activeDesignIdByType[state.productType] = item.sourceDesignId;
      sessionStorage.setItem('iw_template_picker_single_card_v1', JSON.stringify({
        productType: state.productType,
        activeDesignIdByType: state.activeDesignIdByType,
        updatedAt: Date.now(),
      }));
    } catch (error) {}
  }

  function analyticsContext(item, visiblePosition, visibleCount) {
    var context = {
      source_design_id: item.sourceDesignId,
      template_name: String(item.title || '').replace(/\s+/g, ' ').trim().slice(0, 80),
      template_position: item.position,
      template_count: item.templateCount,
      theme_context: item.themeHandle,
      product_type: item.productType,
    };
    if (Number.isFinite(Number(visiblePosition))) {
      context.visible_position = Math.max(1, Number(visiblePosition));
    }
    if (Number.isFinite(Number(visibleCount))) {
      context.visible_count = Math.max(0, Number(visibleCount));
    }
    return context;
  }

  function trackGallery(item, params) {
    state.galleryInteractionCount += 1;
    track('designer_template_gallery_interact', Object.assign(
      {},
      params || {},
      analyticsContext(item)
    ));
  }

  function navigationContext(item, surfaceSection, interactionMethod) {
    return Object.assign({
      surface_section: surfaceSection || 'single_card',
      interaction_method: interactionMethod || 'button',
      card_position: activeIndex() + 1,
      card_count: state.items.length,
    }, analyticsContext(item, activeIndex() + 1, state.items.length));
  }

  function commitNavigation(url) {
    try {
      window.location.assign(url);
    } catch (error) {
      state.navigationPending = false;
      throw error;
    }
  }

  function navigateToTemplate(item, surfaceSection) {
    if (!item || state.navigationPending) return;
    state.navigationPending = true;
    window.__iwSourceDesignId = item.sourceDesignId;
    state.selectedTemplate = item;
    savePickerState();
    try {
      sessionStorage.setItem('iw_template_analytics:' + item.sourceDesignId, JSON.stringify(Object.assign({
        selected_at: Date.now(),
      }, navigationContext(item, surfaceSection, 'button'))));
    } catch (error) {}
    trackAndFlush('designer_template_select', Object.assign({
      result: 'success',
    }, navigationContext(item, surfaceSection, 'button')));
    var url = new URL(window.location.href);
    ['start', 'clone', 'material', 'size', 'buy', 'add', 'productType'].forEach(function (name) {
      url.searchParams.delete(name);
    });
    url.searchParams.set('template', item.sourceDesignId);
    commitNavigation(url.href);
  }

  function navigateToDetail(item, surfaceSection) {
    if (!item || state.navigationPending) return;
    state.navigationPending = true;
    savePickerState();
    trackAndFlush('designer_template_buy_as_shown', Object.assign({
      result: 'success',
    }, navigationContext(item, surfaceSection, 'button')));
    commitNavigation(
      '/pages/design-detail?d=' + encodeURIComponent(item.sourceDesignId) + '&from=designer'
    );
  }

  function createGalleryButton(direction, label) {
    var button = element('button', 'iw-template-card__arrow iw-template-card__arrow--' + direction);
    button.type = 'button';
    button.setAttribute('aria-label', label);
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('aria-hidden', 'true');
    var use = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    use.setAttribute('href', '#i-back');
    icon.appendChild(use);
    button.appendChild(icon);
    return button;
  }

  function createLightbox() {
    var root = element('div', 'iw-template-lightbox');
    root.id = 'iwTemplateLightbox';
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');

    var backdrop = element('div', 'iw-template-lightbox__backdrop');
    backdrop.setAttribute('aria-hidden', 'true');

    var dialog = element('div', 'iw-template-lightbox__dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'iwTemplateLightboxTitle');

    var header = element('div', 'iw-template-lightbox__header');
    var heading = element('h2', 'iw-template-lightbox__title');
    heading.id = 'iwTemplateLightboxTitle';
    var lightboxCounter = element('span', 'iw-template-lightbox__counter');
    lightboxCounter.setAttribute('aria-live', 'polite');
    lightboxCounter.setAttribute('aria-atomic', 'true');
    var closeButton = element('button', 'iw-template-lightbox__close');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Close enlarged image');
    var closeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    closeIcon.setAttribute('aria-hidden', 'true');
    var closeIconUse = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    closeIconUse.setAttribute('href', '#i-zoom-out');
    closeIcon.appendChild(closeIconUse);
    closeButton.appendChild(closeIcon);
    header.appendChild(heading);
    header.appendChild(lightboxCounter);
    header.appendChild(closeButton);

    var stage = element('div', 'iw-template-lightbox__stage');
    var zoomSurface = element('div', 'iw-template-lightbox__zoom-surface');
    var lightboxImage = element('img', 'iw-template-lightbox__image');
    lightboxImage.decoding = 'async';
    lightboxImage.draggable = false;
    var previous = createGalleryButton('previous', 'Previous enlarged image');
    var next = createGalleryButton('next', 'Next enlarged image');
    previous.className = 'iw-template-lightbox__arrow iw-template-lightbox__arrow--previous';
    next.className = 'iw-template-lightbox__arrow iw-template-lightbox__arrow--next';
    zoomSurface.appendChild(lightboxImage);
    stage.appendChild(zoomSurface);
    stage.appendChild(previous);
    stage.appendChild(next);

    var lightboxActions = element('div', 'iw-template-lightbox__actions');
    var lightboxCustomize = element('button', 'iw-template-lightbox__cta iw-template-lightbox__cta--primary', 'Customize');
    var lightboxBuy = element('button', 'iw-template-lightbox__cta iw-template-lightbox__cta--secondary', 'Buy as shown');
    lightboxCustomize.type = 'button';
    lightboxBuy.type = 'button';
    lightboxActions.appendChild(lightboxCustomize);
    lightboxActions.appendChild(lightboxBuy);

    dialog.appendChild(header);
    dialog.appendChild(stage);
    dialog.appendChild(lightboxActions);
    root.appendChild(backdrop);
    root.appendChild(dialog);
    document.body.appendChild(root);

    var active = null;
    var previousBodyOverflow = '';
    var pickerWasInert = false;
    var imageRequestVersion = 0;
    var MIN_ZOOM = 1;
    var MAX_ZOOM = 4;
    var activePointers = new Map();
    var zoomScale = MIN_ZOOM;
    var zoomX = 0;
    var zoomY = 0;
    var pinchStartDistance = 0;
    var pinchStartScale = MIN_ZOOM;
    var pinchAnchorX = 0;
    var pinchAnchorY = 0;
    var panPointerId = null;
    var panStartPoint = null;
    var panStartX = 0;
    var panStartY = 0;
    var tapStartPoint = null;
    var gestureMoved = false;
    var gestureHadMultiplePointers = false;
    var lastTapAt = 0;
    var lastTapPoint = null;

    function clamp(value, minimum, maximum) {
      return Math.min(maximum, Math.max(minimum, value));
    }

    function pointForEvent(event) {
      return {
        x: Number(event.clientX) || 0,
        y: Number(event.clientY) || 0,
      };
    }

    function distanceBetween(first, second) {
      var dx = second.x - first.x;
      var dy = second.y - first.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function midpointBetween(first, second) {
      return {
        x: (first.x + second.x) / 2,
        y: (first.y + second.y) / 2,
      };
    }

    function stageMetrics() {
      var rect = typeof stage.getBoundingClientRect === 'function'
        ? stage.getBoundingClientRect()
        : { left: 0, top: 0, width: 0, height: 0 };
      var width = Math.max(0, Number(rect.width) || Number(stage.clientWidth) || 0);
      var height = Math.max(0, Number(rect.height) || Number(stage.clientHeight) || 0);
      return {
        left: Number(rect.left) || 0,
        top: Number(rect.top) || 0,
        width: width,
        height: height,
        centerX: (Number(rect.left) || 0) + width / 2,
        centerY: (Number(rect.top) || 0) + height / 2,
      };
    }

    function displayedImageSize(metrics) {
      var naturalWidth = Math.max(1, Number(lightboxImage.naturalWidth) || metrics.width || 1);
      var naturalHeight = Math.max(1, Number(lightboxImage.naturalHeight) || metrics.height || 1);
      var fit = Math.min(metrics.width / naturalWidth, metrics.height / naturalHeight);
      if (!Number.isFinite(fit) || fit <= 0) return { width: 0, height: 0 };
      return {
        width: naturalWidth * fit,
        height: naturalHeight * fit,
      };
    }

    function clampZoomPosition() {
      zoomScale = clamp(Number(zoomScale) || MIN_ZOOM, MIN_ZOOM, MAX_ZOOM);
      if (zoomScale <= MIN_ZOOM) {
        zoomScale = MIN_ZOOM;
        zoomX = 0;
        zoomY = 0;
        return;
      }
      var metrics = stageMetrics();
      var displayed = displayedImageSize(metrics);
      var maxX = Math.max(0, (displayed.width * zoomScale - metrics.width) / 2);
      var maxY = Math.max(0, (displayed.height * zoomScale - metrics.height) / 2);
      zoomX = clamp(Number(zoomX) || 0, -maxX, maxX);
      zoomY = clamp(Number(zoomY) || 0, -maxY, maxY);
    }

    function applyZoomTransform() {
      clampZoomPosition();
      zoomSurface.style.transform = 'translate3d('
        + zoomX.toFixed(2) + 'px, '
        + zoomY.toFixed(2) + 'px, 0) scale('
        + zoomScale.toFixed(3) + ')';
      zoomSurface.classList.toggle('is-zoomed', zoomScale > MIN_ZOOM);
      root.dataset.zoomScale = zoomScale.toFixed(3);
    }

    function resetZoom() {
      activePointers.clear();
      zoomScale = MIN_ZOOM;
      zoomX = 0;
      zoomY = 0;
      pinchStartDistance = 0;
      pinchStartScale = MIN_ZOOM;
      panPointerId = null;
      panStartPoint = null;
      tapStartPoint = null;
      gestureMoved = false;
      gestureHadMultiplePointers = false;
      zoomSurface.classList.remove('is-interacting');
      applyZoomTransform();
    }

    function zoomAtPoint(targetScale, point) {
      var metrics = stageMetrics();
      var localX = point.x - metrics.centerX;
      var localY = point.y - metrics.centerY;
      var anchorX = (localX - zoomX) / zoomScale;
      var anchorY = (localY - zoomY) / zoomScale;
      zoomScale = clamp(targetScale, MIN_ZOOM, MAX_ZOOM);
      zoomX = localX - anchorX * zoomScale;
      zoomY = localY - anchorY * zoomScale;
      applyZoomTransform();
    }

    function isMobileTouchEvent(event) {
      if (!event || event.pointerType !== 'touch') return false;
      if (typeof window.matchMedia !== 'function') return true;
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function pointerPair() {
      var values = Array.from(activePointers.values());
      return values.length >= 2 ? [values[0], values[1]] : null;
    }

    function startPinch() {
      var pair = pointerPair();
      if (!pair) return;
      var midpoint = midpointBetween(pair[0], pair[1]);
      var metrics = stageMetrics();
      pinchStartDistance = Math.max(1, distanceBetween(pair[0], pair[1]));
      pinchStartScale = zoomScale;
      pinchAnchorX = (midpoint.x - metrics.centerX - zoomX) / zoomScale;
      pinchAnchorY = (midpoint.y - metrics.centerY - zoomY) / zoomScale;
      gestureHadMultiplePointers = true;
      panPointerId = null;
      panStartPoint = null;
    }

    function startPan(pointerId, point) {
      panPointerId = pointerId;
      panStartPoint = { x: point.x, y: point.y };
      panStartX = zoomX;
      panStartY = zoomY;
    }

    function onZoomPointerDown(event) {
      if (!active || !isMobileTouchEvent(event)) return;
      var point = pointForEvent(event);
      try {
        if (typeof zoomSurface.setPointerCapture === 'function') {
          zoomSurface.setPointerCapture(event.pointerId);
        }
      } catch (error) {}
      activePointers.set(event.pointerId, point);
      zoomSurface.classList.add('is-interacting');
      if (activePointers.size === 1) {
        tapStartPoint = point;
        gestureMoved = false;
        startPan(event.pointerId, point);
      } else if (activePointers.size === 2) {
        startPinch();
      } else {
        gestureHadMultiplePointers = true;
      }
    }

    function onZoomPointerMove(event) {
      if (!activePointers.has(event.pointerId) || !isMobileTouchEvent(event)) return;
      var previousPoint = activePointers.get(event.pointerId);
      var point = pointForEvent(event);
      activePointers.set(event.pointerId, point);
      if (distanceBetween(previousPoint, point) > 2) gestureMoved = true;

      if (activePointers.size >= 2) {
        var pair = pointerPair();
        if (!pair) return;
        if (!pinchStartDistance) startPinch();
        var midpoint = midpointBetween(pair[0], pair[1]);
        var metrics = stageMetrics();
        zoomScale = clamp(
          pinchStartScale * distanceBetween(pair[0], pair[1]) / pinchStartDistance,
          MIN_ZOOM,
          MAX_ZOOM
        );
        zoomX = midpoint.x - metrics.centerX - pinchAnchorX * zoomScale;
        zoomY = midpoint.y - metrics.centerY - pinchAnchorY * zoomScale;
        applyZoomTransform();
        event.preventDefault();
        return;
      }

      if (zoomScale > MIN_ZOOM && panPointerId === event.pointerId && panStartPoint) {
        zoomX = panStartX + point.x - panStartPoint.x;
        zoomY = panStartY + point.y - panStartPoint.y;
        applyZoomTransform();
        event.preventDefault();
      }
    }

    function handleDoubleTap(event, point) {
      var now = Number(event.timeStamp) || Date.now();
      var isSecondTap = Boolean(
        lastTapAt
        && now - lastTapAt <= 320
        && lastTapPoint
        && distanceBetween(lastTapPoint, point) <= 32
      );
      if (isSecondTap) {
        if (zoomScale > MIN_ZOOM) resetZoom();
        else zoomAtPoint(2, point);
        lastTapAt = 0;
        lastTapPoint = null;
        return;
      }
      lastTapAt = now;
      lastTapPoint = point;
    }

    function finishZoomPointer(event, cancelled) {
      if (!activePointers.has(event.pointerId)) return;
      var point = activePointers.get(event.pointerId);
      var wasSingleTap = !cancelled
        && activePointers.size === 1
        && !gestureMoved
        && !gestureHadMultiplePointers
        && tapStartPoint
        && distanceBetween(tapStartPoint, point) <= 8;
      activePointers.delete(event.pointerId);
      try {
        if (typeof zoomSurface.releasePointerCapture === 'function') {
          zoomSurface.releasePointerCapture(event.pointerId);
        }
      } catch (error) {}

      pinchStartDistance = 0;
      if (activePointers.size === 1 && zoomScale > MIN_ZOOM) {
        var remaining = Array.from(activePointers.entries())[0];
        startPan(remaining[0], remaining[1]);
      } else if (!activePointers.size) {
        zoomSurface.classList.remove('is-interacting');
        if (zoomScale < 1.03) resetZoom();
        else applyZoomTransform();
        if (wasSingleTap) handleDoubleTap(event, point);
        gestureMoved = false;
        gestureHadMultiplePointers = false;
        panPointerId = null;
        panStartPoint = null;
        tapStartPoint = null;
      }
    }

    function onZoomPointerUp(event) {
      finishZoomPointer(event, false);
    }

    function onZoomPointerCancel(event) {
      finishZoomPointer(event, true);
    }

    function activeIndex() {
      if (!active) return 0;
      return cyclicIndex(active.getIndex(), 0, active.item.images.length);
    }

    function sync() {
      if (!active) return;
      resetZoom();
      var item = active.item;
      var index = activeIndex();
      var image = item.images[index];
      var requestVersion = ++imageRequestVersion;
      var requestActive = active;
      var settled = false;
      heading.textContent = item.title;
      lightboxCounter.textContent = (index + 1) + ' / ' + item.images.length;
      lightboxImage.alt = image.alt || item.title + ', enlarged image ' + (index + 1) + ' of ' + item.images.length;
      previous.hidden = item.images.length <= 1;
      next.hidden = item.images.length <= 1;
      root.classList.add('is-image-loading');
      root.classList.remove('is-image-error');
      stage.setAttribute('aria-busy', 'true');
      stage.setAttribute('aria-label', 'Loading enlarged image');

      function isCurrentRequest() {
        return Boolean(
          active
          && active === requestActive
          && imageRequestVersion === requestVersion
        );
      }

      function revealImage() {
        if (settled || !isCurrentRequest()) return;
        settled = true;
        root.classList.remove('is-image-loading', 'is-image-error');
        stage.removeAttribute('aria-busy');
        stage.removeAttribute('aria-label');
      }

      function handleLoad() {
        if (settled || !isCurrentRequest()) return;
        if (typeof lightboxImage.decode !== 'function') {
          revealImage();
          return;
        }
        lightboxImage.decode()
          .catch(function () {
            /* A completed load is still renderable when decode() rejects after
             * the resource has reached the browser cache. */
          })
          .then(revealImage);
      }

      function handleError() {
        if (settled || !isCurrentRequest()) return;
        settled = true;
        lightboxImage.removeAttribute('src');
        lightboxImage.alt = '';
        root.classList.remove('is-image-loading');
        root.classList.add('is-image-error');
        stage.removeAttribute('aria-busy');
        stage.setAttribute('aria-label', 'Image unavailable');
      }

      lightboxImage.onload = handleLoad;
      lightboxImage.onerror = handleError;
      lightboxImage.src = image.url;
      if (lightboxImage.complete && lightboxImage.naturalWidth > 0) {
        window.requestAnimationFrame(handleLoad);
      }
    }

    function shift(delta, interactionType) {
      if (!active || active.item.images.length <= 1) return;
      var index = cyclicIndex(activeIndex(), delta, active.item.images.length);
      active.updateImage(index, interactionType);
    }

    function close(closeMethod) {
      if (!active) return;
      var closing = active;
      var index = activeIndex();
      trackGallery(closing.item, {
        interaction_type: 'lightbox_close',
        image_index: index + 1,
        image_count: closing.item.images.length,
        close_method: closeMethod || 'unknown',
      });
      imageRequestVersion += 1;
      lightboxImage.onload = null;
      lightboxImage.onerror = null;
      lightboxImage.removeAttribute('src');
      lightboxImage.alt = '';
      resetZoom();
      active = null;
      root.hidden = true;
      root.classList.remove('is-open', 'is-image-loading', 'is-image-error');
      root.setAttribute('aria-hidden', 'true');
      stage.removeAttribute('aria-busy');
      stage.removeAttribute('aria-label');
      document.body.style.overflow = previousBodyOverflow;
      document.body.classList.remove('iw-template-lightbox-open');
      if (!pickerWasInert) picker.removeAttribute('inert');
      if (closing.trigger) closing.trigger.setAttribute('aria-expanded', 'false');
      if (closing.trigger && closing.trigger.isConnected) closing.trigger.focus();
    }

    function open(item, trigger, updateImage, getIndex) {
      if (active) close('replace');
      pickerWasInert = picker.hasAttribute('inert');
      previousBodyOverflow = document.body.style.overflow;
      active = {
        item: item,
        trigger: trigger,
        updateImage: updateImage,
        getIndex: getIndex,
      };
      sync();
      root.hidden = false;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      picker.setAttribute('inert', '');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('iw-template-lightbox-open');
      trigger.setAttribute('aria-expanded', 'true');
      trackGallery(item, {
        interaction_type: 'lightbox_open',
        image_index: activeIndex() + 1,
        image_count: item.images.length,
      });
      window.requestAnimationFrame(function () { closeButton.focus(); });
    }

    function focusableElements() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        function (node) {
          return !node.disabled && !node.hidden && node.getAttribute('aria-hidden') !== 'true';
        }
      );
    }

    function onKeydown(event) {
      if (!active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close('escape');
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        shift(-1, 'lightbox_previous');
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        shift(1, 'lightbox_next');
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (!focusable.length) {
        event.preventDefault();
        dialog.focus();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    backdrop.addEventListener('click', function () { close('backdrop'); });
    closeButton.addEventListener('click', function () { close('close_button'); });
    previous.addEventListener('click', function () { shift(-1, 'lightbox_previous'); });
    next.addEventListener('click', function () { shift(1, 'lightbox_next'); });
    lightboxCustomize.addEventListener('click', function () {
      if (active) navigateToTemplate(active.item, 'lightbox');
    });
    lightboxBuy.addEventListener('click', function () {
      if (active) navigateToDetail(active.item, 'lightbox');
    });
    zoomSurface.addEventListener('pointerdown', onZoomPointerDown);
    zoomSurface.addEventListener('pointermove', onZoomPointerMove);
    zoomSurface.addEventListener('pointerup', onZoomPointerUp);
    zoomSurface.addEventListener('pointercancel', onZoomPointerCancel);
    lightboxImage.addEventListener('dragstart', function (event) { event.preventDefault(); });
    document.addEventListener('keydown', onKeydown);
    if (typeof window.addEventListener === 'function') {
      window.addEventListener('resize', function () {
        if (active) resetZoom();
      });
    }
    resetZoom();

    return {
      open: open,
      close: close,
      sync: sync,
      getZoomState: function () {
        return { scale: zoomScale, x: zoomX, y: zoomY };
      },
      isOpenFor: function (item) {
        return Boolean(active && active.item.sourceDesignId === item.sourceDesignId);
      },
    };
  }

  var lightbox = createLightbox();

  function observeCard(card, item, visiblePosition, visibleCount) {
    var viewKey = state.productType + ':' + item.sourceDesignId;
    var sendView = function () {
      if (state.viewedTemplateKeys.has(viewKey)) return;
      state.viewedTemplateKeys.add(viewKey);
      track('designer_template_card_view', Object.assign({
        result: 'visible',
        surface_section: 'single_card',
        card_position: visiblePosition,
        card_count: visibleCount,
      }, analyticsContext(item, visiblePosition, visibleCount)));
    };
    if (typeof IntersectionObserver !== 'function') {
      sendView();
      return;
    }
    var timer = 0;
    var observer = new IntersectionObserver(function (entries) {
      var entryRecord = entries[0];
      if (entryRecord && entryRecord.isIntersecting && entryRecord.intersectionRatio >= 0.5) {
        if (!timer) {
          timer = window.setTimeout(function () {
            timer = 0;
            sendView();
            observer.disconnect();
          }, 500);
        }
      } else if (timer) {
        window.clearTimeout(timer);
        timer = 0;
      }
    }, { threshold: [0, 0.5, 1] });
    observer.observe(card);
  }

  function preloadAdjacent() {
    if (!state.items.length || typeof Image !== 'function') return;
    [activeIndex() - 1, activeIndex() + 1].forEach(function (index) {
      var item = state.items[index];
      if (!item || !item.images[0]) return;
      var image = new Image();
      image.src = item.images[0].url;
    });
  }

  function focusAfterRender(selector) {
    window.requestAnimationFrame(function () {
      var node = listNode.querySelector(selector);
      if (node) node.focus();
    });
  }

  function setActiveDesign(nextIndex, interactionMethod, focusSelector) {
    if (!state.items.length) return;
    var previous = activeItem();
    var next = Math.max(0, Math.min(state.items.length - 1, Number(nextIndex) || 0));
    if (next === activeIndex()) return;
    state.activeIndexByType[state.productType] = next;
    var item = activeItem();
    state.activeDesignIdByType[state.productType] = item.sourceDesignId;
    savePickerState();
    renderList();
    preloadAdjacent();
    track('designer_template_card_change', Object.assign({
      previous_source_design_id: previous ? previous.sourceDesignId : '',
      interaction_method: interactionMethod || 'unknown',
      card_position: next + 1,
      card_count: state.items.length,
      result: 'success',
    }, analyticsContext(item, next + 1, state.items.length)));
    if (focusSelector) focusAfterRender(focusSelector);
  }

  function shiftActive(delta, interactionMethod, focusSelector) {
    setActiveDesign(activeIndex() + delta, interactionMethod, focusSelector);
  }

  function createCard(item, visiblePosition, visibleCount) {
    var card = element('article', 'iw-template-card');
    card.dataset.sourceDesignId = item.sourceDesignId;

    var gallery = element('div', 'iw-template-card__gallery');
    var mainTrigger = element('button', 'iw-template-card__main-trigger');
    mainTrigger.type = 'button';
    mainTrigger.setAttribute('aria-haspopup', 'dialog');
    mainTrigger.setAttribute('aria-controls', 'iwTemplateLightbox');
    mainTrigger.setAttribute('aria-expanded', 'false');
    var main = element('img', 'iw-template-card__main-image');
    main.loading = 'eager';
    main.decoding = 'async';
    mainTrigger.appendChild(main);
    var previous = createGalleryButton('previous', 'Previous design');
    var next = createGalleryButton('next', 'Next design');
    previous.hidden = visibleCount <= 1;
    next.hidden = visibleCount <= 1;
    previous.disabled = visiblePosition <= 1;
    next.disabled = visiblePosition >= visibleCount;
    gallery.appendChild(mainTrigger);
    gallery.appendChild(previous);
    gallery.appendChild(next);
    card.appendChild(gallery);

    var copy = element('div', 'iw-template-card__copy');
    var eyebrow = element('div', 'iw-template-card__eyebrow');
    eyebrow.appendChild(element('span', 'iw-template-card__theme', item.themeName));
    if (visiblePosition <= 6) {
      eyebrow.appendChild(element('span', 'iw-template-card__recommended', 'Recommended'));
    }
    var titleRow = element('div', 'iw-template-card__title-row');
    titleRow.appendChild(element('h2', 'iw-template-card__title', item.title));
    titleRow.appendChild(element('strong', 'iw-template-card__price', priceLabel(item)));
    copy.appendChild(eyebrow);
    copy.appendChild(titleRow);
    copy.appendChild(element(
      'span',
      'iw-template-card__meta',
      'Handmade to order · Review before purchase'
    ));
    card.appendChild(copy);

    var actions = element('div', 'iw-template-card__actions');
    var customize = element('button', 'iw-template-card__cta iw-template-card__cta--primary', 'Customize');
    var buy = element('button', 'iw-template-card__cta iw-template-card__cta--secondary', 'Buy as shown');
    customize.type = 'button';
    buy.type = 'button';
    customize.addEventListener('click', function () { navigateToTemplate(item, 'single_card'); });
    buy.addEventListener('click', function () { navigateToDetail(item, 'single_card'); });
    actions.appendChild(customize);
    actions.appendChild(buy);
    card.appendChild(actions);

    var switcher = element('div', 'iw-template-card__switcher');
    var previousText = element('button', 'iw-template-card__switch iw-template-card__switch--previous', '‹ Previous');
    var choose = element('button', 'iw-template-card__choose');
    var chooseIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    var chooseUse = document.createElementNS('http://www.w3.org/2000/svg', 'use');
    chooseUse.setAttribute('href', '#i-category-all');
    chooseIcon.setAttribute('aria-hidden', 'true');
    chooseIcon.appendChild(chooseUse);
    choose.appendChild(chooseIcon);
    choose.appendChild(element('span', '', 'Choose design'));
    var nextText = element('button', 'iw-template-card__switch iw-template-card__switch--next', 'Next ›');
    previousText.type = 'button';
    choose.type = 'button';
    nextText.type = 'button';
    previousText.disabled = visiblePosition <= 1;
    nextText.disabled = visiblePosition >= visibleCount;
    previousText.addEventListener('click', function () {
      shiftActive(-1, 'previous_button', '.iw-template-card__switch--previous');
    });
    nextText.addEventListener('click', function () {
      shiftActive(1, 'next_button', '.iw-template-card__switch--next');
    });
    choose.addEventListener('click', openChooser);
    switcher.appendChild(previousText);
    switcher.appendChild(choose);
    switcher.appendChild(nextText);
    card.appendChild(switcher);

    function updateImage(nextIndex, interactionType) {
      var index = cyclicIndex(nextIndex, 0, item.images.length);
      state.imageIndexes.set(item.sourceDesignId, index);
      var image = item.images[index];
      main.src = image.url;
      main.alt = image.alt || item.title + ', image ' + (index + 1) + ' of ' + item.images.length;
      mainTrigger.setAttribute(
        'aria-label',
        'Open larger view of ' + item.title + ', image ' + (index + 1) + ' of ' + item.images.length
      );
      if (interactionType) {
        trackGallery(item, {
          interaction_type: interactionType,
          image_index: index + 1,
          image_count: item.images.length,
        });
      }
      if (lightbox.isOpenFor(item)) lightbox.sync();
    }

    var swipeStart = null;
    var suppressOpen = false;
    mainTrigger.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'mouse') return;
      swipeStart = { x: event.clientX, y: event.clientY, id: event.pointerId };
    });
    mainTrigger.addEventListener('pointerup', function (event) {
      if (!swipeStart || swipeStart.id !== event.pointerId) return;
      var dx = event.clientX - swipeStart.x;
      var dy = event.clientY - swipeStart.y;
      swipeStart = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) <= Math.abs(dy) * 1.2) return;
      suppressOpen = true;
      event.preventDefault();
      if (dx < 0) shiftActive(1, 'swipe');
      else shiftActive(-1, 'swipe');
    });
    mainTrigger.addEventListener('pointercancel', function () { swipeStart = null; });
    mainTrigger.addEventListener('click', function (event) {
      if (suppressOpen) {
        suppressOpen = false;
        event.preventDefault();
        return;
      }
      lightbox.open(
        item,
        mainTrigger,
        updateImage,
        function () { return state.imageIndexes.get(item.sourceDesignId) || 0; }
      );
    });
    previous.addEventListener('click', function () {
      shiftActive(-1, 'image_arrow', '.iw-template-card__arrow--previous');
    });
    next.addEventListener('click', function () {
      shiftActive(1, 'image_arrow', '.iw-template-card__arrow--next');
    });
    updateImage(state.imageIndexes.get(item.sourceDesignId) || 0);
    observeCard(card, item, visiblePosition, visibleCount);
    return card;
  }

  function renderChooserGrid() {
    if (!chooserGrid) return;
    var items = filteredItems();
    chooserGrid.replaceChildren();
    items.forEach(function (item) {
      var button = element('button', 'iw-design-chooser__item');
      var selected = activeItem() && activeItem().sourceDesignId === item.sourceDesignId;
      button.type = 'button';
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.setAttribute('aria-label', 'Choose ' + item.title + ', ' + priceLabel(item));
      var image = element('img', 'iw-design-chooser__image');
      image.src = item.images[0].url;
      image.alt = '';
      image.loading = 'lazy';
      image.decoding = 'async';
      var copy = element('span', 'iw-design-chooser__copy');
      copy.appendChild(element('strong', '', item.title));
      copy.appendChild(element('small', '', priceLabel(item)));
      button.appendChild(image);
      button.appendChild(copy);
      button.addEventListener('click', function () {
        var index = state.items.findIndex(function (candidate) {
          return candidate.sourceDesignId === item.sourceDesignId;
        });
        closeChooser('select');
        if (index >= 0 && index !== activeIndex()) {
          track('designer_design_picker_select', Object.assign({
            interaction_method: 'picker',
            card_position: index + 1,
            card_count: state.items.length,
            result: 'success',
          }, analyticsContext(item, index + 1, state.items.length)));
          setActiveDesign(index, 'picker');
        }
      });
      chooserGrid.appendChild(button);
    });
    if (!items.length) {
      chooserGrid.appendChild(element('p', 'iw-design-chooser__empty', 'No designs in this theme yet.'));
    }
  }

  function renderThemes() {
    themesNode.replaceChildren();
    [{ handle: 'all', name: 'All Themes' }].concat(state.themes).forEach(function (theme) {
      var button = element('button', 'iw-template-picker__theme', theme.name);
      var active = state.activeTheme === theme.handle;
      button.type = 'button';
      button.dataset.theme = theme.handle;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.addEventListener('click', function () {
        if (state.activeTheme === theme.handle) return;
        state.activeTheme = theme.handle;
        renderThemes();
        renderChooserGrid();
        track('designer_theme_filter_select', {
          theme_context: theme.handle,
          template_count: state.items.length,
          visible_count: filteredItems().length,
          product_type: state.productType,
          result: 'success',
        });
      });
      themesNode.appendChild(button);
    });
  }

  function renderList() {
    var item = activeItem();
    listNode.replaceChildren();
    statusNode.hidden = Boolean(item);
    if (!item) {
      countNode.textContent = '0 / 0';
      progressNode.style.setProperty('--iw-template-progress', '0%');
      statusNode.textContent = 'No published ' + state.productType + ' designs are available yet.';
      return;
    }
    var position = activeIndex() + 1;
    countNode.textContent = position + ' / ' + state.items.length;
    progressNode.style.setProperty(
      '--iw-template-progress',
      Math.max(0, Math.min(100, position / state.items.length * 100)).toFixed(2) + '%'
    );
    listNode.appendChild(createCard(item, position, state.items.length));
    statusNode.hidden = true;
  }

  function syncProductTabs() {
    if (!productTabsNode) return;
    Array.prototype.forEach.call(
      productTabsNode.querySelectorAll('[data-product-type]'),
      function (button) {
        var active = button.dataset.productType === state.productType;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.disabled = state.loadingProductType;
      }
    );
  }

  async function setProductType(productType) {
    var nextType = productType === 'necklace' ? 'necklace' : 'bracelet';
    if (nextType === state.productType || state.navigationPending || state.loadingProductType) return;
    var previous = activeItem();
    if (previous) state.activeDesignIdByType[state.productType] = previous.sourceDesignId;
    state.productType = nextType;
    state.activeTheme = 'all';
    state.loadingProductType = true;
    syncProductTabs();
    picker.setAttribute('aria-busy', 'true');
    statusNode.hidden = false;
    statusNode.textContent = 'Loading ' + nextType + ' designs…';
    listNode.replaceChildren();
    countNode.textContent = 'Loading…';
    progressNode.style.setProperty('--iw-template-progress', '0%');
    track('designer_product_type_select', {
      product_type: nextType,
      interaction_method: 'product_tab',
      result: 'success',
    });
    try {
      await loadTemplates(false);
    } finally {
      state.loadingProductType = false;
      syncProductTabs();
    }
  }

  function chooserFocusable() {
    if (!chooserDialog) return [];
    return Array.prototype.filter.call(
      chooserDialog.querySelectorAll('button, [href], [tabindex]:not([tabindex="-1"])'),
      function (node) { return !node.disabled && !node.hidden; }
    );
  }

  function openChooser(event) {
    if (!chooserRoot || !chooserDialog) return;
    state.chooserReturnFocus = event && event.currentTarget ? event.currentTarget : document.activeElement;
    state.chooserPreviousOverflow = document.body.style.overflow;
    state.chooserPickerWasInert = picker.hasAttribute('inert');
    state.activeTheme = 'all';
    renderThemes();
    renderChooserGrid();
    chooserTitle.textContent = state.productType === 'necklace'
      ? 'Choose a necklace design'
      : 'Choose a bracelet design';
    chooserRoot.hidden = false;
    chooserRoot.setAttribute('aria-hidden', 'false');
    picker.setAttribute('inert', '');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('iw-design-chooser-open');
    track('designer_design_picker_open', {
      product_type: state.productType,
      template_count: state.items.length,
      card_position: activeIndex() + 1,
      card_count: state.items.length,
      result: 'open',
    });
    window.requestAnimationFrame(function () { chooserClose.focus(); });
  }

  function closeChooser(method) {
    if (!chooserRoot || chooserRoot.hidden) return;
    chooserRoot.hidden = true;
    chooserRoot.setAttribute('aria-hidden', 'true');
    if (!state.chooserPickerWasInert) picker.removeAttribute('inert');
    document.body.style.overflow = state.chooserPreviousOverflow;
    document.body.classList.remove('iw-design-chooser-open');
    if (method !== 'select' && state.chooserReturnFocus && state.chooserReturnFocus.isConnected) {
      state.chooserReturnFocus.focus();
    }
  }

  function onChooserKeydown(event) {
    if (!chooserRoot || chooserRoot.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeChooser('escape');
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = chooserFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function showError(error) {
    picker.removeAttribute('aria-busy');
    countNode.textContent = 'Published designs unavailable';
    listNode.replaceChildren();
    themesNode.replaceChildren();
    statusNode.hidden = false;
    statusNode.replaceChildren();
    statusNode.appendChild(element('strong', '', 'We couldn’t load the designs.'));
    statusNode.appendChild(element('span', '', 'Check your connection and try again.'));
    var retry = element('button', 'iw-template-picker__retry', 'Try again');
    retry.type = 'button';
    retry.addEventListener('click', function () {
      state.retryCount += 1;
      track('designer_template_list_retry', {
        retry_count: state.retryCount,
        product_type: state.productType,
        theme_context: state.activeTheme,
        result: 'retry',
      });
      statusNode.textContent = 'Loading designs…';
      picker.setAttribute('aria-busy', 'true');
      loadTemplates(true);
    });
    statusNode.appendChild(retry);
    track('designer_template_list_error', {
      error_code: analyticsErrorCode(error, 'template_list_failed'),
      stage: 'list_fetch',
      retry_count: state.retryCount,
      product_type: state.productType,
      theme_context: state.activeTheme,
      result: 'error',
      load_ms: Math.max(0, Math.round(performance.now() - Number(startedAt))),
    });
    console.error('[iwobbl templates] list load failed', error);
  }

  async function loadTemplates(force) {
    try {
      var normalized = !force && state.cacheByType[state.productType];
      if (!normalized) {
        var data = await requestTemplates(Boolean(force));
        normalized = normalizeResponse(data);
        state.cacheByType[state.productType] = normalized;
      }
      state.items = normalized.items;
      state.themes = normalized.themes;
      state.activeTheme = 'all';
      var activeId = state.activeDesignIdByType[state.productType];
      var restoredIndex = activeId
        ? state.items.findIndex(function (item) { return item.sourceDesignId === activeId; })
        : -1;
      state.activeIndexByType[state.productType] = restoredIndex >= 0
        ? restoredIndex
        : Math.max(0, Math.min(
          state.items.length - 1,
          Number(state.activeIndexByType[state.productType]) || 0
        ));
      renderThemes();
      renderList();
      syncProductTabs();
      preloadAdjacent();
      savePickerState();
      picker.removeAttribute('aria-busy');
      track('designer_template_list_ready', {
        template_count: state.items.length,
        theme_count: state.themes.length,
        theme_context: 'all',
        product_type: state.productType,
        retry_count: state.retryCount,
        result: 'success',
        load_ms: Math.max(0, Math.round(performance.now() - Number(startedAt))),
      });
    } catch (error) {
      showError(error);
    }
  }

  blankButton.addEventListener('click', function () {
    state.startedBlank = true;
    trackAndFlush('designer_start_blank', {
      product_type: state.productType,
      theme_context: state.activeTheme,
      template_count: state.items.length,
      result: 'success',
    });
    var url = new URL(window.location.href);
    ['template', 'clone', 'material', 'size', 'buy', 'add'].forEach(function (name) {
      url.searchParams.delete(name);
    });
    url.searchParams.set('start', 'blank');
    url.searchParams.set('productType', state.productType);
    window.location.assign(url.href);
  });

  function updateMaxScroll() {
    var root = document.documentElement;
    var scrollable = Math.max(0, root.scrollHeight - window.innerHeight);
    var current = scrollable > 0
      ? Math.round(Math.max(0, Math.min(1, window.scrollY / scrollable)) * 100)
      : 0;
    state.maxScrollPct = Math.max(state.maxScrollPct, current);
  }

  function handlePickerPageShow(event) {
    if (!event || event.persisted !== true) return;
    state.navigationPending = false;
    state.loadingProductType = false;
    state.exitSent = false;
    state.selectedTemplate = null;
    state.startedBlank = false;
    state.maxScrollPct = 0;
    startedAt = performance.now();
    syncProductTabs();
    picker.removeAttribute('aria-busy');
    updateMaxScroll();
    track('designer_template_list_view', {
      product_type: state.productType,
      theme_context: state.activeTheme,
      result: 'history_restore',
    });
  }

  function sendExitSummary() {
    if (state.exitSent) return;
    state.exitSent = true;
    updateMaxScroll();
    var destination = state.selectedTemplate
      ? 'template'
      : (state.startedBlank ? 'blank' : 'exit');
    var params = {
      active_seconds: Math.max(0, Math.round((performance.now() - Number(startedAt)) / 1000)),
      max_scroll_pct: state.maxScrollPct,
      viewed_template_count: state.viewedTemplateKeys.size,
      gallery_interaction_count: state.galleryInteractionCount,
      template_count: state.items.length,
      theme_context: state.activeTheme,
      product_type: state.productType,
      destination: destination,
      selected_template: Boolean(state.selectedTemplate),
      started_blank: state.startedBlank,
    };
    if (state.selectedTemplate) Object.assign(params, analyticsContext(state.selectedTemplate));
    trackAndFlush('designer_template_list_exit_summary', params);
  }

  if (chooserClose) chooserClose.addEventListener('click', function () { closeChooser('close_button'); });
  if (chooserBackdrop) chooserBackdrop.addEventListener('click', function () { closeChooser('backdrop'); });
  document.addEventListener('keydown', onChooserKeydown);
  if (productTabsNode) {
    productTabsNode.addEventListener('click', function (event) {
      var button = event.target.closest('[data-product-type]');
      if (!button || !productTabsNode.contains(button)) return;
      setProductType(button.dataset.productType);
    });
  }

  restorePickerState();
  syncProductTabs();
  track('designer_template_list_view', {
    product_type: state.productType,
    theme_context: 'all',
    result: 'visible',
  });
  updateMaxScroll();
  window.addEventListener('scroll', updateMaxScroll, { passive: true });
  window.addEventListener('pagehide', sendExitSummary);
  window.addEventListener('pageshow', handlePickerPageShow);

  loadTemplates(false);
})();
